import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTSelect {
    $onChanges() {
        const firstOptionValue = this.getFirstOptionValue();
        const value = _.isNil(this.value) && !this.isNullable ? firstOptionValue : this.value;
        const selectedOption = (this.options || []).find(option => option.value === value);

        if (selectedOption) {
            this.setSelectedOption(selectedOption);
            this.closeOptions();
        }
    }

    getFirstOptionValue() {
        if (this.options && this.options.length > 0) {
            return this.options[0].value;
        }

        return null;
    }

    setShownState(state) {
        this.showOptions = state;
    }

    setSelectedOption(selectedOption) {
        this.selectedOption = selectedOption;
    }

    closeOptions() {
        this.setShownState(false);
    }

    onClickOutside() {
        this.closeOptions();
    }

    onButtonClick() {
        this.setShownState(!this.showOptions);
    }

    async onOptionClick(option) {
        if(option.isDivider){
            return
        }

        const shouldSelect = await this.onOptionSelect({ option });
        if(shouldSelect === false){
            this.closeOptions();
            return;
        }
        this.setSelectedOption(option);
        this.closeOptions();
    }
}

export const TFTSelectConfiguration = {
    template,
    controller: TFTSelect,
    bindings: {
        value: '<',
        options: '<',
        disabled: '<',
        onOptionSelect: '&',
        testId: '@',
        isNullable: '<',
    },
    controllerAs: 'selectCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftSelect', TFTSelectConfiguration);
